import { render, staticRenderFns } from "./AdvertiserTask.vue?vue&type=template&id=268ed42e&scoped=true"
import script from "./AdvertiserTask.vue?vue&type=script&lang=js"
export * from "./AdvertiserTask.vue?vue&type=script&lang=js"
import style0 from "./AdvertiserTask.vue?vue&type=style&index=0&id=268ed42e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268ed42e",
  null
  
)

export default component.exports